<!-- Template -->

<template>
    <div>
        <Header  />

        <TopNavigation :path="path" :loading="loading" :fullWidth="mobile || tablet" />
        <div id="mobile-nav-toggler" v-show="navTogglerVisible" :class="mobileNavClass">
            <a href="#" @click.prevent="toggleNavigation()">
                <span :class="mobileNavIcon"></span>
            </a>
        </div>
        <section id="main-container">
            <div class="bg container" v-if="bgVisible" ref="bg" :class="{ visible: bgVisible }"></div>

            <div class="container" ref="container">
                <div class="row app">
                    <div v-if="!loading && !firstPage">
                        <RequestSupportButton />
                    </div>
                    <span v-if="loading" class="spinner-border main-loader"></span>

                    <HospitalNavigation
                        :active="hospital"
                        :hospitals="hospitals"
                        v-if="!loading"
                        ref="hospitalNavigation"
                    />

                    <div v-if="hospital" class="col-11 pr-0" :class="{fullWidth: mobile || tablet}">
                        <div class="tab-content">
                            <div class="tab-pane active">
                                <div class="row">
                                    <Sidebar
                                        :active="section"
                                        :hospital="hospital"
                                        @contactDetailsAreChanged2="changeName($event)"
                                        ref="sidebar"
                                    />

                                    <div
                                        v-if="$slots.default"
                                        class="col-9 main-column" :class="{fullWidth: mobile || tablet}"
                                        ref="mainColumn"
                                    >
                                        <div class="tab-content">
                                            <div class="tab-pane active">
                                                <slot />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer />
    </div>
</template>

<!-- Script -->

<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import Sidebar from "@/components/Sidebar";
    import TopNavigation from "@/components/TopNavigation";
    import HospitalNavigation from "@/components/HospitalNavigation";
    import RequestSupportButton from "@/components/RequestSupportButton";
    import { isMobile, isTablet, isBrowser } from "mobile-device-detect";

    export default {
        name: "DefaultLayout",

        components: {
            Header,
            Footer,
            Sidebar,
            TopNavigation,
            HospitalNavigation,
            RequestSupportButton
        },

        data() {
            return {
                bgVisible: true,
                mobile: isMobile,
                tablet: isTablet,
                browser: isBrowser,
                navTogglerVisible: false,
                mobileNavVisible: false,
                mobileNavIcon: "icon-hamburger",
                mobileNavClass: "white"
            };
        },

        computed: {
            firstPage() {
                return this.$route.path === "/hospitals";
            },

            sidebar() {
                return this.$refs.sidebar;
            },
            hospitalNavigation() {
                return this.$refs.hospitalNavigation;
            }
        },

        props: ["path", "hospital", "hospitals", "section", "loading"],

        mounted() {
            var body = document.body;

            if (this.mobile) {
                body.classList.add("mobile");
                this.navTogglerVisible = true;
            }
            if (this.tablet) {
                body.classList.add("tablet");
                this.navTogglerVisible = true;
            }
            if (this.browser) {
                body.classList.remove("mobile", "tablet");
                this.navTogglerVisible = false;
            }
        },

        created() {
            if (this.$route.name != "Hospitals" && this.$route.name != "Hospital") {
                this.bgVisible = false;
            }
        },

        methods: {
            changeName(data) {
                this.$emit("contactDetailsAreChanged3", data);
            },

            toggleNavigation() {
                if (!this.mobileNavVisible) {
                    if (this.sidebar || this.hospitalNavigation) {
                        this.mobileNavVisible = true;
                        if (this.sidebar) {
                            this.sidebar.show();
                        }
                        if (this.hospitalNavigation) {
                            this.hospitalNavigation.show();
                        }
                        this.mobileNavIcon = "icon-x";
                        this.mobileNavClass = "blue";
                    }
                } else {
                    if (this.sidebar || this.hospitalNavigation) {
                        this.mobileNavVisible = false;
                        if (this.sidebar) {
                            this.sidebar.hide();
                        }
                        if (this.hospitalNavigation) {
                            this.hospitalNavigation.hide();
                        }
                        this.mobileNavIcon = "icon-hamburger";
                        this.mobileNavClass = "white";
                    }
                }
            }
        }
    };
</script>

